import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { DeleteDialogService } from "services/delete-dialog-service";
import { ErrorService } from "services/error-service";
import { SewingThreadTypeServiceService } from "services/sewing-thread-type-service-service";
import { ToastService } from "services/toast-service";

@autoinject
export class SewingThreadTypeServiceDetail {
  private sewingThreadTypeService: Models.SewingThreadTypeService;
  protected checkDuplicateData: Models.CheckDuplicateSewingThreadTypeService = new Models.CheckDuplicateSewingThreadTypeService();

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private sewingThreadTypeServiceService: SewingThreadTypeServiceService,
    private deleteDialogService: DeleteDialogService
  ) {}

  protected activate(params: { Id: string }) {
    this.sewingThreadTypeServiceService
      .get(params.Id)
      .then((res) => {
        this.sewingThreadTypeService = res;
      })
      .catch((err) => this.errorService.handleError(err));
  }

  protected async updateSewingThreadTypeService() {
    try {
      if (await this.checkDuplicate()) return;

      await this.sewingThreadTypeServiceService.put(this.sewingThreadTypeService, this.sewingThreadTypeService.Id);
      this.eventAggregator.publish('sewingThreadTypeServiceListReset', 1);
      this.toastService.showSuccess('sewingThread.updated');
      this.router.navigateToRoute('sewing-thread-type-service-list');
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.Id = this.sewingThreadTypeService.Id;
    this.checkDuplicateData.ProductId = this.sewingThreadTypeService.ProductId;
    const { IsDuplicate } = await this.sewingThreadTypeServiceService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('sewingThreadTypeServiceIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }

  protected deleteSewingThreadTypeService() {
    void this.deleteDialogService.confirmBeforeDelete(() => {
      this.sewingThreadTypeServiceService
        .delete(this.sewingThreadTypeService.Id)
        .then(() => {
          this.eventAggregator.publish('sewingThreadTypeServiceListReset', 1);
          this.toastService.showSuccess('sewingThread.deleted');
          this.router.navigateToRoute('sewing-thread-type-service-list');
        })
        .catch((err) => this.errorService.handleError(err));
    });
  }

  protected gotoParentView() {
    this.eventAggregator.publish('sewingThreadTypeServiceListReset', 1);
    this.router.navigateToRoute('sewing-thread-type-service-list');
  }
}